import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import { StatusLabel } from '@administrate/piston-ux';
import { DateTime } from 'luxon';
import ItemBlock from './ItemBlock';
import { CATALOG_ITEM_IMAGE_PLACEHOLDER } from '../../../constants';
import { formatDate } from '../../../utils/formatDateTime';
import { hasEventStartedByDateObject } from '../../../utils/hasEventStarted';

// TODO: Move this to a more generic place
export const getRemainingPlacesText = (remainingPlaces, t) =>
  `${t('weblink:placesRemaining')}: ${
    remainingPlaces === null ? t('weblink:unlimited') : remainingPlaces
  }`;

const EventItem = ({
  id,
  location,
  startDateTime,
  deliveryMethod,
  course,
  remainingPlaces,
  imageUrl,
  isSoldOut,
  showPlacesRemaining,
  t,
}) => (
  <ItemBlock
    title={course}
    type="large"
    image={imageUrl || CATALOG_ITEM_IMAGE_PLACEHOLDER}
    details={
      <>
        {location && (
          <span className="ItemBlock_detail__location">{`${location}, `}</span>
        )}
        <span className="ItemBlock_detail__date">
          {deliveryMethod === 'lms'
            ? hasEventStartedByDateObject(startDateTime)
              ? t('weblink:uponEnrolment')
              : // This is required to show the local date rather than the date in the timezone that the LMS event has been set up in.
                formatDate(DateTime.fromMillis(startDateTime.ts))
            : formatDate(startDateTime)}
        </span>
        <div style={{ lineHeight: 1.5 }}>
          {showPlacesRemaining && (
            <span className="ItemBlock_detail__places">
              {getRemainingPlacesText(remainingPlaces, t)}
            </span>
          )}
          {isSoldOut && (
            <StatusLabel
              extraClass="sold-out-status-label"
              color="red"
              text={t('weblink:soldOut')}
            />
          )}
        </div>
      </>
    }
    dataTestId={`cart-row-product-option-${id}-description`}
  />
);

EventItem.defaultProps = {
  location: null,
  imageUrl: CATALOG_ITEM_IMAGE_PLACEHOLDER,
  startDateTime: null,
  remainingPlaces: null,
  isSoldOut: false,
  showPlacesRemaining: true,
};

EventItem.propTypes = {
  id: PropTypes.string.isRequired,
  location: PropTypes.string,
  imageUrl: PropTypes.string,
  startDateTime: PropTypes.instanceOf(DateTime),
  course: PropTypes.string.isRequired,
  remainingPlaces: PropTypes.number,
  deliveryMethod: PropTypes.string.isRequired,
  isSoldOut: PropTypes.bool,
  showPlacesRemaining: PropTypes.bool,
  t: PropTypes.func.isRequired,
};

export default withTranslation()(EventItem);
